import {
  ID,
  SortingMode,
  Task,
  TaskListTreeItem,
  Timestamp,
  WeekDays,
} from '@griply/types';
import { buildTasksTree } from '@griply/utils';
import { useMemo } from 'react';

export type Options = {
  tasks: Task[];
  customOrder?: Record<ID, ID[]>;
  sortingMode?: SortingMode | null;
  today: Timestamp;
  weekStartsOn: WeekDays;
  hideNewTaskRow?: boolean;
};

export const useTasksTree = ({
  tasks,
  customOrder,
  sortingMode,
  today,
  weekStartsOn,
  hideNewTaskRow,
}: Options) =>
  useMemo<Record<ID, TaskListTreeItem>>(
    () =>
      buildTasksTree({
        tasks,
        customOrder,
        sortingMode,
        today,
        weekStartsOn,
        hideNewTaskRow,
        rootLabel: 'Root',
        newTaskLabel: 'New Task',
      }),
    [customOrder, sortingMode, tasks, today, weekStartsOn, hideNewTaskRow],
  );
